import * as macro from './macro';

export default macro.default;